import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';

import { ScreenTitle } from '../../../../components/atoms';
import LoadingModal from '../../../../components/atoms/LoadingModal/index';
import { withSnackbar } from 'notistack';

const PAGE_SIZE = 4;

const TestResults = ({
  userId,
  sessionToken,
  testResult,
  loading,
  enqueueSnackbar, state,
  dashboardTestResultFetch = () => {
  },
}) => {

  const [currentPage, updateCurrentPage] = useState(0);

  const TestQuesData = [
    ['Federal Mortgage Related Laws'],
    ['General Mortgage Knowledge'],
    ['Mortgage Loan Origination Activities'],
    ['Ethics Loan Origination Activities'],
    ['Uniform State Content'],
  ];

  const handlePageClick = ({ selected }) => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    updateCurrentPage(selected);
  };

  useEffect(() => {
    fetchTestResult();
  }, []);

  const fetchTestResult = () => {
    dashboardTestResultFetch(
      {
        userId: userId,
        sessionToken: sessionToken,
      },
      (message, type) => {
        enqueueSnackbar(message, {
          variant: type,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
        });
      },
    );
  };

  const renderTableView = (data) => {
    let score = 0;
    let total_questions = 0;

    data.results.forEach((itm) => {
      score = score + Number(itm.correct_answer);
      total_questions = total_questions + Number(itm.total_question);
    });

    const final_score = Math.round((score / total_questions) * 100);

    return (
      <div className='col6' key={data.id}>
        <div className='result_block'>
          <h5>
            T E S T<span>R E S U L T</span>
          </h5>
          <div className='result_list'>
            <ul>
              <li>
                <span className='result_title'>TOPIC</span>
                <span className='result_title'>Result</span>
              </li>
              {TestQuesData.map((rowData, index) => (
                <li key={index}>
                  <span> {[rowData[0]]}</span>
                  <span>{`${data.results[index].avg_corect_ques}%`}</span>
                </li>
              ))}

              <li>
                <span className='f_title'>Total</span>
                <span className='f_title'>
                  {`${final_score}%`}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const renderTestResults = (testResult) => {
    if (Object.keys(testResult).length !== 0) {
      return (
        <>
          <div className='test_result'>
            <div className='row'>
              {Object.keys(testResult).slice(currentPage * PAGE_SIZE, (currentPage + 1) * PAGE_SIZE).map((item, index) => {
                return renderTableView({
                  id: index,
                  name: index + 1,
                  results: testResult[item],
                });
              })}
            </div>
          </div>
          {Object.keys(testResult).length > PAGE_SIZE && (
            <ReactPaginate
              nextClassName={'next-button'}
              previousClassName={'next-button'}
              pageCount={Object.keys(testResult).length / PAGE_SIZE}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          )}
        </>
      );
    } else {
      return (
        <div className='no_result'>
          <span>No Test Given Yet.</span>
        </div>
      );
    }
  };

  return (
    <>
      <ScreenTitle title='Dashboard' subTitle='Simulated Test Results'/>

      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : (
        renderTestResults(testResult)
      )}
    </>
  );
};
export default withSnackbar(TestResults);
